import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';
import { CONFIG_URLS_API } from 'src/environments/config-envs';
import { environment } from 'src/environments/environment';
import { LoginModel } from '../model/login.model';
import { LocalStorageService } from '../services/localstorage.service';
import {
  AcordoPostoResponse,
  AcordoRedeEspecialBase,
  AcordoRedeEspecialBaseList,
  AcordoStatusResponse,
  CombustivelContrato,
  GetAcordosPendentesFilterModel,
  PayloadCancelarAcordo,
  PayloadCriarAcordo,
} from './rede-especial.interface';

@Injectable({
  providedIn: 'root',
})
export class RedeEspecialService {
  private readonly http = inject(HttpClient);
  private localStorageService = inject(LocalStorageService);
  public usuario!: LoginModel;

  constructor() {
    var userData = this.localStorageService.getItem('userData');
    if (userData != null) {
      this.usuario = JSON.parse(userData);
    }
  }
  private getHeaders(): { headers: HttpHeaders } {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        userGuid: this.usuario?.retorno?.guid,
      }),
    };
  }

  getListaCombustiveis(guid: string) {
    return this.http
      .get<CombustivelContrato[]>(
        `${
          environment.host_ctf_service +
          CONFIG_URLS_API.API_ConsultaListaCombustiveis
        }${guid}`
      )
      .pipe(
        catchError((error) => {
          console.error('Erro ao buscar combustíveis:', error);
          return of([]);
        }),

        map((res: any) => {
          return res.retorno
            .filter(
              (combustivel: any) => combustivel.descricaoCombustivel !== ''
            )
            .sort((a: any, b: any) => {
              return a.ordem < b.ordem;
            });
        })
      );
  }

  criarNovoAcordo(
    payload: PayloadCriarAcordo
  ): Observable<AcordoRedeEspecialBase> {
    console.log('Payload Criar Acordo:', payload);

    return this.http.post<AcordoRedeEspecialBase>(
      `${environment.host_ctf_service + CONFIG_URLS_API.API_CriarNovoAcordo}`,
      payload,
      this.getHeaders()
    );
  }

  getAcordoStatus(): Observable<AcordoStatusResponse> {
    return this.http.get<AcordoStatusResponse>(
      `${environment.host_ctf_service + CONFIG_URLS_API.API_GetAcordoStatus}`,
      this.getHeaders()
    );
  }

  getAcordosPendentes(
    filter: GetAcordosPendentesFilterModel
  ): Observable<AcordoPostoResponse> {
    return this.http.post<AcordoPostoResponse>(
      `${
        environment.host_ctf_service +
        CONFIG_URLS_API.API_GetAcordosPendentesAsync
      }`,
      filter,
      this.getHeaders()
    );
  }

  aprovarOuRejeitarAcordos(
    acordos: AcordoRedeEspecialBaseList
  ): Observable<AcordoRedeEspecialBase> {
    return this.http.post<AcordoRedeEspecialBase>(
      `${
        environment.host_ctf_service +
        CONFIG_URLS_API.API_AprovarOuRejeitarAcordosAsync
      }`,
      acordos,
      this.getHeaders()
    );
  }
  /*
  rejeitarAcordos(
    acordos: AcordoRedeEspecialBaseList
  ): Observable<AcordoRedeEspecialBase> {
    return this.http.post<AcordoRedeEspecialBase>(
      `${
        environment.host_ctf_service + CONFIG_URLS_API.API_RejeitarAcordosAsync
      }`,
      acordos,
      this.getHeaders()
    );
  }
*/
  cancelarAcordo(
    payloadAprovar: PayloadCancelarAcordo[]
  ): Observable<AcordoRedeEspecialBase> {
    return this.http.post<AcordoRedeEspecialBase>(
      `${
        environment.host_ctf_service + CONFIG_URLS_API.API_CancelarAcordosAsync
      }`,
      payloadAprovar,
      this.getHeaders()
    );
  }
}
